module.exports = __webpack_public_path__ + "static/1-woman-london-10ecd3f97c29450648b43371c3754908.jpg";